<template>
  <div class="app-container superAdmin-page">
    <div class="filter-container">
      <div class="filter-title">筛选经销商账号</div>
      <div class="filter-form-container">
        <el-input
          v-model="listQuery.account"
          clearable
          placeholder="请输入账号"
          class="filter-item filter-form-item title-input"
          @keyup.enter.native="handleFilter"
        />

        <el-select
          v-model="listQuery.status"
          clearable
          placeholder="请选择状态"
          class="filter-item filter-form-item status-select"
          @change="handleFilter"
        >
          <el-option
            v-for="item in statusOptions"
            :key="item.key"
            :label="item.label"
            :value="item.key"
          />
        </el-select>

        <el-button v-waves class="filter-item" type="default" @click="handleFilter">搜索</el-button>
        <el-button v-waves class="filter-item" type="default" @click="handleFilter($event,true)">重置</el-button>

        <!-- <el-button
          class="filter-item add-btn"
          style="margin-left: 10px;"
          type="primary"
          icon="el-icon-edit"
          @click="showCreate = true"
        >新增账号</el-button> -->
      </div>
    </div>

    <!-- <div class="multi-opt" style="margin-bottom: 20px">
      <el-button :disabled="disabledMultiOpt" @click="handleUpdateMutilStatus(0)">
        批量禁用
      </el-button>

      <el-button :disabled="disabledMultiOpt" @click="handleUpdateMutilStatus(1)">
        批量启用
      </el-button>

      <el-button :disabled="disabledMultiOpt" @click="handleUpdateMutilStatus(2)">
        批量删除
      </el-button>
    </div> -->

    <el-table
      v-loading="listLoading"
      :data="list"
      border
      fit
      highlight-current-row
      type="index"
      style="width: 100%"
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" width="55" />

      <el-table-column align="center" label="账号ID" width="80">
        <template slot-scope="scope">
          <span>{{ scope.row.id }}</span>
        </template>
      </el-table-column>

      <el-table-column align="center" label="账号">
        <template slot-scope="scope">
          <span>{{ scope.row.account }}</span>
        </template>
      </el-table-column>

      <el-table-column align="center" label="使用者昵称">
        <template slot-scope="scope">
          <span>{{ scope.row.real_name ? scope.row.real_name : '-' }}</span>
        </template>
      </el-table-column>

      <el-table-column align="center" label="关联OA账号">
        <template slot-scope="scope">
          <span>{{ scope.row.customer_number ? scope.row.customer_number : '-' }}</span>
        </template>
      </el-table-column>

      <el-table-column align="center" label="手机号">
        <template slot-scope="scope">
          <span>{{ scope.row.phone || '-' }} </span>
        </template>
      </el-table-column>

      <el-table-column align="center" label="角色" width="300">
        <template slot-scope="scope">
          <p v-for="(item, idx) in getAccountRoles(scope.row.roles)" :key="idx">
            {{ item }}
          </p>
          <span v-if="!scope.row.roles || scope.row.roles.length === 0">-</span>
        </template>
      </el-table-column>

      <el-table-column align="center" label="最近操作时间">
        <template slot-scope="scope">
          <span>{{ (scope.row.updated_at || new Date()) | parseTime('{y}-{m}-{d} {h}:{i}') }}</span>
        </template>
      </el-table-column>

      <el-table-column align="center" label="最近操作账号">
        <template slot-scope="scope">
          <span>{{ scope.row.operate_user ? scope.row.operate_user.account : '-' }}</span>
        </template>
      </el-table-column>

      <el-table-column class-name="status-col" label="状态" width="160">
        <template slot-scope="{row}">
          <span
            :class="row.status ? 'success-text' : 'danger-text'"
          >已{{ row.status | statusFilter }}</span>
        </template>
      </el-table-column>

      <el-table-column align="center" label="操作" width="300">
        <template slot-scope="scope">
          <div class="table-btn-container">
            <!-- <el-button
              type="text"
              size="small"
              @click="isShowAuth = true; accountInfo = scope.row;"
            >账号授权</el-button> -->

            <!-- <el-button
              type="text"
              size="small"
              @click="showManage = true; accountInfo = scope.row; index = scope.$index"
            >编辑</el-button> -->

            <el-button
              type="text"
              size="small"
              @click="onShowEditPassword(scope.row, scope.$index)"
            >重置密码</el-button>

            <!-- <el-popconfirm
              class="table-btn"
              :title="scope.row.status | confirmTitle"
              @onConfirm="handleUpdateMutilStatus(scope.row.status ? 0 : 1, [scope.row.id])"
            >
              <el-button
                slot="reference"
                type="text"
                size="small"
              >{{ (scope.row.status ? 0 : 1) | statusFilter }}</el-button>
            </el-popconfirm> -->
          </div>
        </template>
      </el-table-column>
    </el-table>

    <pagination
      v-show="total>0"
      :total="total"
      :page.sync="listQuery.page"
      :limit.sync="listQuery.limit"
      @pagination="getList"
    />

    <edit-password-dialog :show.sync="showEditPassword" :account-info="accountInfo" />

    <add-account :show.sync="showCreate" :is-dealer="1" @update="getList" />

    <authorization-modal :show.sync="isShowAuth" :account-info="accountInfo" :platform-ids="[6]" @updateInfo="getList" />

    <manage-account :show.sync="showManage" :account-info="accountInfo" @updateInfo="updateInfo" />
  </div>
</template>

<script>
import _ from 'lodash'
import { fetchAccountList, updateAccount, updateMultiStatus } from '@/api/account'
import waves from '@/directive/waves' // waves directive
import Pagination from '@/components/Pagination' // Secondary package based on el-pagination
import EditPasswordDialog from '@/components/ManageAccount/superAdmin/editPassword'
import AddAccount from '@/components/addSuperAdminAccount'
import AuthorizationModal from '@/components/authorizationModal'
import ManageAccount from '@/components/ManageAccount/superAdmin'
import { SUERP_ADMIN_PLATFORM_ARR, SUERP_ADMIN_PLATFORM_MAP } from '@/constances/superAdmin'

const statusMap = {
  1: '启用',
  0: '禁用'
}

const initialQuery = {
  page: 1,
  limit: 20,
  is_dealer: 1,
  account: '',
  status: '',
  platform_id: ''
}

export default {
  name: 'SuperAdminList',
  components: {
    Pagination,
    EditPasswordDialog,
    AddAccount,
    ManageAccount,
    AuthorizationModal
  },
  directives: { waves },
  filters: {
    statusFilter(status) {
      return statusMap[status]
    },
    confirmTitle(status) {
      const text = `确认${statusMap[status ? 0 : 1]}该账号？`
      return text
    },
    parseUsername(user) {
      const username = _.get(user, ['username'])
      return username || '-'
    },
    filterAddress(data) {
      return (
        _.get(data, ['provinces', 'region_name']) +
        _.get(data, ['citys', 'region_name']) +
        _.get(data, ['areas', 'region_name']) +
        data.address
      )
    },
    getPlatforms(platforms = []) {
      return platforms.map(item => item.platform_name).join(',')
    }
  },
  data() {
    return {
      SUERP_ADMIN_PLATFORM_ARR,
      SUERP_ADMIN_PLATFORM_MAP,
      list: null,
      total: 0,
      listLoading: true,
      listQuery: {
        ...initialQuery
      },
      brandList: [], // 品牌列表
      statusOptions: [],
      showEditPassword: false,
      accountInfo: {},
      showCreate: false,
      showManage: false,
      multipleSelection: [],
      index: -1, // 当前编辑账号索引
      isShowAuth: false
    }
  },

  computed: {
    disabledMultiOpt() {
      return !this.multipleSelection?.length
    }
  },

  created() {
    // 初始化筛状态
    this.statusOptions = Object.keys(statusMap).map((key) => ({
      key,
      label: statusMap[key]
    }))
    this.getList()
  },
  methods: {
    // 获取列表
    getList() {
      console.log(this.listQuery)
      this.listLoading = true
      fetchAccountList(this.listQuery).then((response) => {
        this.list = response.data.data
        this.total = response.data.total
        this.listLoading = false
      })
    },
    // 列表查询
    handleFilter($event, isClear) {
      this.listQuery.page = 1
      console.log(isClear)
      if (isClear) {
        this.listQuery = {
          ...initialQuery
        }
      }
      this.getList()
    },
    // 编辑状态
    async updateStatus(row) {
      console.log(row)
      const payload = {
        real_name: row.real_name,
        id: row.id,
        status: row.status ? 0 : 1
      }
      this.updateReq(payload, row)
    },
    // update请求
    async updateReq(payload, row) {
      const index = this.list.findIndex((v) => v.id === row.id)
      this.listLoading = true
      try {
        const res = await updateAccount(payload.id, {
          ...payload
        })
        this.listLoading = false
        this.list.splice(index, 1, {
          ...row,
          ...res.data
        })
        this.$notify({
          title: '操作成功',
          message: '编辑成功',
          type: 'success',
          duration: 2000
        })
        this.getList()
      } catch (e) {
        this.listLoading = false
        console.log(e)
      }
    },

    // 修改密码
    onShowEditPassword(info, index) {
      console.log(index)
      this.showEditPassword = true
      this.accountInfo = info
    },

    // 更新账号信息
    updateInfo(data) {
      this.getList()
    },

    // 批量选择
    handleSelectionChange(val = []) {
      this.multipleSelection = val.map(item => item.id)
    },

    // 批量更新
    async handleUpdateMutilStatus(status, ids = this.multipleSelection) {
      this.listLoading = true
      try {
        await updateMultiStatus({
          ids,
          status
        })
        this.listLoading = false
        this.getList()
        this.dialogFormVisible = false
        this.$notify({
          title: '操作成功',
          message: '编辑成功',
          type: 'success',
          duration: 2000
        })
      } catch (e) {
        this.listLoading = false
        console.log(e)
      }
    },

    // 获取账号角色
    getAccountRoles(roles = []) {
      const _roles = _.sortBy(roles, (item) => item.platform_id)
      return _roles.map(item => `${item.platform.platform_name} -- ${item.name}`)
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/styles/form-table.scss";
.superAdmin-page ::v-deep .el-form-item__content {
  margin-left: 130px !important;
}

.superAdmin-img {
  width: 28px;
  height: 28px;
  &:not(:last-child) {
    margin-right: 10px;
  }
}

.table-btn-container {
  padding: 0 10px;
  display: flex;
  align-items: center;
  justify-content: space-around;
  .table-btn:not(:last-child) {
    margin-right: 0;
  }
}
</style>
